import * as React from 'react'
import * as Styles from './HomeItemTag.style'

interface HomeItemTagProp {
    text: string
}

export default class HomeItemTag extends React.Component <HomeItemTagProp> {
    public render() {
        return (
            <div className={Styles.WkNewTag}>
            <div className={Styles.TagContent} style={{border: '1px solid #666666', color: '#666666', width: '48px'}}>
                <span>{this.props.text}</span>
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendLectureItemList/HomeItemTag.tsx